/** Unicode combining-diacritical-marks block (U+0300..U+036F) — what NFKD decomposition
 *  splits accented letters into (e.g. "e with acute accent" -> "e" + U+0301). Expressed
 *  as numeric code points rather than a regex character-range literal so the range
 *  survives verbatim through tooling that treats `\u` escapes as literal-character
 *  directives. */
const COMBINING_DIACRITICS_START = 0x0300;
const COMBINING_DIACRITICS_END = 0x036f;
function isCombiningDiacritic(char) {
    const code = char.codePointAt(0) ?? 0;
    return code >= COMBINING_DIACRITICS_START && code <= COMBINING_DIACRITICS_END;
}
/** Normalizes calendar/client text for stable matching. */
export function normalizedText(value) {
    return Array.from(value.normalize('NFKD'))
        .filter((char) => !isCombiningDiacritic(char))
        .join('')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
}
/**
 * Normalizes a PERSON's name for stable identity matching (dedup, Clerk-user linking):
 * NFKD-decompose -> strip combining diacritics -> lowercase -> collapse whitespace -> trim.
 *
 * Deliberately does NOT route through {@link normalizedText}: that normalizer strips ALL
 * punctuation, which collapses "Ann-Marie" into "Ann Marie" and "O'Brien" into "O Brien" —
 * fine for client/title matching (where punctuation is noise), but dangerous for person
 * names, where a hyphen or apostrophe is part of the name itself. Two different people
 * ("Ann Marie" and "Ann-Marie") must never normalize to the same key, and a transcript
 * speaker must never be mislinked to the wrong `clerk_user_id` (which feeds attendee-
 * visibility RLS) because their surname's punctuation got stripped. Hyphens and apostrophes
 * are therefore preserved as meaningful characters; only whitespace is collapsed.
 */
export function normalizePersonName(name) {
    return Array.from(name.normalize('NFKD'))
        .filter((char) => !isCombiningDiacritic(char))
        .join('')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, ' ');
}
